//
//
//

export default {
    name: 'loginTransfers',
    data () {
        return {
            text: ''
        }
    },
    methods: {
        getProvince () {
            var p = new Promise((resolve, reject) => {
                var adddress = '',
                province = '',
                loadScript;
                function loadJS(url) { //加载js
                loadScript = document.createElement("script");
                loadScript.type = "text/javascript";
                loadScript.src = url;
                document.body.appendChild(loadScript);
                }
                loadJS("https://pv.sohu.com/cityjson?ie=utf-8");
                loadScript.onload = function () {

                adddress = returnCitySN["cname"]
                

                if(adddress.split('省').length != 1) {
                    province = adddress.split('省')[0]+'省'
                }else if(adddress.split('区').length != 1){
                    province = adddress.split('区')[0]+'区'
                }else{
                    province = adddress.split('市')[0]+'市'
                }
                resolve(province)
                }
            })
            return p
        },
        setCookie(cname, cvalue, exdays) {
            //cname 名字
            //cvalue 值
            //exdays 时间            0.01大概25分钟
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + "; " + expires+"; path=/"   //这个很重要代表在那个层级下可以访问cookie
            console.log(d)
        },
    },
    created () {
        // window.history.replaceState(null,null,window.location.origin+'/'+window.location.hash)
        this.$vux.loading.show({
            text: 'Loading'
        })
    },
    mounted () {
        //此页面是第三方登录的中转站，判断齐思印账号是否已绑定QQ
        let that = this,
            accessToken = this.$route.query.accessToken,
            openId = this.$route.query.openId,
            nickname = this.$route.query.nickname;
        that.getProvince().then((province) => {
            that.$request.post('/user/checkQQOpenId',{
                openId,
                province,
            }).then(data => {
                console.log(JSON.parse(JSON.stringify(data)))
                if(data.code == 0){
                    that.$vux.loading.hide()
                    if(data.obj.openId == false){
                        // location.href = location.href.replace('/?#/','/#/')
                        // alert(location.href)
                        if(that.$route.query.type == 'login'){
                            that.$router.push({
                                path: '/thirdPartyLogin',
                                query: {
                                    openId,
                                    accessToken,
                                    nickname
                                }
                            }) 
                        }else if(that.$route.query.type == 'bind' || that.$route.query.types == 'bindQQFlag'){
                            // alert(that.$common.getCookie('_token'))
                            // location.href = location.origin+location.pathname+'#/personalData?types=bindQQFlag&hasBind=false&openId='+openId+'&accessToken='+accessToken+'&nickname='+nickname
                            // location.href = 'https://www.baidu.com'
                            that.$router.push({
                                path: '/personalData',
                                query: {
                                    types: 'bindQQFlag',
                                    token: that.$route.query.token,
                                    hasBind: false,
                                    openId,
                                    accessToken,
                                    nickname
                                }
                            }) 
                        }
                        // location.href = location.origin+'/#/thirdPartyLogin'
                        // alert(location.href)
                    }else{
                        if(that.$route.query.type == 'login'){
                            that.$vux.toast.show({
                                type: 'success',
                                text: data.msg,
                                time: 600
                            })
                            
                            let vPath = that.$route.query.fullPath
                            that.setCookie('_token', data.obj.token, 0.288);
                            that.setCookie('_isMonthlyKnots', data.obj.monthlyKnots, 0.288);
                            // console.log('-----'+that.$common.getCookie('_token'))
                            that.$token = data.obj.token
                            that.$emit("loginCallback", false, data);
                            setTimeout(() => {
                                vPath ? that.$router.push({path: vPath}) : that.$router.push({path: '/'})
                                // that.$router.push({
                                //   path: '/'
                                // })
                            }, 650);
                        }else if(that.$route.query.type == 'bind' || that.$route.query.types == 'bindQQFlag'){
                            // that.$vux.toast.show({
                            //     type: 'warn',
                            //     text: '该QQ已被其他账号绑定',
                            //     time: 600
                            // })
                            that.$router.push({
                                path: '/personalData',
                                query: {
                                    type: 'bindQQFlag',
                                    hasBind: true
                                }
                            }) 
                        }
                    }
                    // localStorage.removeItem('qsy_mobile_type')
                }else{
                    that.$vux.loading.hide()
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: data.msg
                    })
                }
            }).catch(e => {
                console.log(e)
            })
        })
        // if(QC.Login.check()){
        //     alert('你以为啊')
        //     // that.$router.push({
        //     //     path: '/thirdPartyLogin'
        //     // }) 
        //     QC.Login.getMe(function (openId, accessToken) {
        //         alert(openId)
        //         that.getProvince().then((province) => {
        //             alert(province)
        //             that.$request.post('/user/checkQQOpenId',{
        //                 openId,
        //                 province,
        //             }).then(data => {
        //                 console.log(JSON.parse(JSON.stringify(data)))
        //                 if(data.code == 0){
        //                     that.$vux.loading.hide()
        //                     // alert(1)
        //                     if(data.obj.openId == false){
        //                         // location.href = location.href.replace('/?#/','/#/')
        //                         // alert(location.href)
        //                         if(that.$route.query.type == 'login'){
        //                             that.$router.push({
        //                                 path: '/thirdPartyLogin'
        //                             }) 
        //                         }else if(that.$route.query.type == 'bind'){
        //                             // alert(that.$common.getCookie('_token'))
        //                             that.$router.push({
        //                                 path: '/personalData',
        //                                 query: {
        //                                     type: 'bindQQFlag',
        //                                     hasBind: false
        //                                 }
        //                             }) 
        //                         }
        //                         // location.href = location.origin+'/#/thirdPartyLogin'
        //                         // alert(location.href)
        //                     }else{
        //                         if(that.$route.query.type == 'login'){
        //                             that.$vux.toast.show({
        //                                 type: 'success',
        //                                 text: data.msg,
        //                                 time: 600
        //                             })
                                    
        //                             let vPath = that.$route.query.fullPath
        //                             that.setCookie('_token', data.obj.token, 0.288);
        //                             that.setCookie('_isMonthlyKnots', data.obj.monthlyKnots, 0.288);
        //                             // console.log('-----'+that.$common.getCookie('_token'))
        //                             that.$token = data.obj.token
        //                             that.$emit("loginCallback", false, data);
        //                             setTimeout(() => {
        //                                 vPath ? that.$router.push({path: vPath}) : that.$router.push({path: '/'})
        //                                 // that.$router.push({
        //                                 //   path: '/'
        //                                 // })
        //                             }, 650);
        //                         }else if(that.$route.query.type == 'bind'){
        //                             // that.$vux.toast.show({
        //                             //     type: 'warn',
        //                             //     text: '该QQ已被其他账号绑定',
        //                             //     time: 600
        //                             // })
        //                             that.$router.push({
        //                                 path: '/personalData',
        //                                 query: {
        //                                     type: 'bindQQFlag',
        //                                     hasBind: true
        //                                 }
        //                             }) 
        //                         }
        //                     }
        //                     // localStorage.removeItem('qsy_mobile_type')
        //                 }else{
        //                     that.$vux.loading.hide()
        //                     that.$vux.toast.show({
        //                         type: 'cancel',
        //                         text: data.msg
        //                     })
        //                 }
        //             }).catch(e => {
        //                 console.log(e)
        //             })
        //         })
        //         // QC.api('get_user_info', {
        //         //     access_token: accessToken,
        //         //     openid: openId
        //         // }).success (function(res){
        //         //     that.text = res.data.nickname + '，你好！'
        //         //     console.log(res)
        //         // })
        //     });
        // }else{
        //     this.$vux.loading.hide()
        //     alert('登录失败')
        //     location.href = location.origin+'/#/login'
        // }
    }
}



// WEBPACK FOOTER //
// ./src/views/loginTransfers/loginTransfers.vue